<template>
  <div class="city">
    <van-nav-bar title="选择城市" fixed left-text="返回" left-arrow @click-left="onClickLeft" />
    <div style="height:46px;"></div>
    <van-index-bar :index-list="indexList">
    <div v-for="item in list" :key="item.index">
      <van-index-anchor :index="item.lentten">{{item.lentten}}</van-index-anchor>

      <van-cell v-for="i in item.city" :key="i.index" :title="i.area_name" v-on:click="sel(i)" />
    </div>
      
    </van-index-bar>
  </div>
</template>
<script>
import Vue from "vue";
import { IndexBar, IndexAnchor, Cell, CellGroup } from "vant";

Vue.use(IndexBar).use(CellGroup).use( Cell);
Vue.use(IndexAnchor);
export default {
  name: "city",
  data() {
    return {
      indexList: ['A','B','C','D','E','F','G','H','J','K','L','M','N','P','Q','R','S','T','W','X','Y','Z'],
      list:{}
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    sel(i){
        localStorage.setItem('city',JSON.stringify(i));
        this.$router.go(-1);
    },
    getData() {
      this.$http
        .get(this.GLOBAL.API + "s_area/area/getCity", {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(
          response => {
            let data = response.body;
            if (data.code == 1) {
                
              this.list = data.data;
            }
          },
         
        );
    }
  },
  mounted(){
      this.getData();
  }
};
</script>
<style lang="scss" scoped>
.city{
    background-color:#f6f6f6 ;
    text-align: left;
}
</style>